const cards = [
  {
    title: '《繁花》高清全集',
    desc: '胡歌、马伊琍领衔主演，王家卫首部电视剧，上海滩商战风云录，豆瓣高分力荐。',
    tag: '热播剧集',
    tagColor: 'bg-primary-100 text-primary-700',
    img: 'https://readdy.ai/api/search-image?query=Cinematic%20scene%20with%20warm%20golden%20lighting%20and%20nostalgic%20Shanghai%20aesthetic%2C%20vintage%20atmosphere%20with%20soft%20bokeh%20background%2C%20elegant%20retro%20film%20style%2C%20no%20text%2C%20cinematic%20composition&width=800&height=600&seq=card-01&orientation=landscape',
  },
  {
    title: '《狂飙》全集重温',
    desc: '张译、张颂文主演现象级刑侦剧，扫黑风暴精彩绝伦，全网热议不断。',
    tag: '经典回顾',
    tagColor: 'bg-accent-100 text-accent-700',
    img: 'https://readdy.ai/api/search-image?query=Dramatic%20cinematic%20composition%20with%20deep%20shadows%20and%20warm%20contrast%20lighting%2C%20urban%20noir%20aesthetic%2C%20suspenseful%20mood%2C%20film%20grain%20texture%2C%20no%20text%2C%20atmospheric%20scene&width=800&height=600&seq=card-02&orientation=landscape',
  },
  {
    title: '《庆余年》第二季',
    desc: '张若昀回归，古装权谋大剧续作，范闲京都风云再起，口碑炸裂新篇章。',
    tag: '独家首推',
    tagColor: 'bg-secondary-100 text-secondary-700',
    img: 'https://readdy.ai/api/search-image?query=Elegant%20ancient%20Chinese%20palace%20aesthetic%20with%20warm%20lantern%20glow%20and%20soft%20atmospheric%20haze%2C%20traditional%20architecture%20silhouette%2C%20cinematic%20lighting%2C%20no%20text%2C%20dreamy%20composition&width=800&height=600&seq=card-03&orientation=landscape',
  },
  {
    title: '《三体》科幻巨制',
    desc: '刘慈欣原著改编，国产科幻里程碑，视觉震撼剧情烧脑，不容错过。',
    tag: '科幻大片',
    tagColor: 'bg-primary-100 text-primary-700',
    img: 'https://readdy.ai/api/search-image?query=Futuristic%20sci-fi%20abstract%20cosmic%20scene%20with%20deep%20space%20gradients%20and%20ethereal%20light%20beams%2C%20minimalist%20geometric%20composition%2C%20dark%20mysterious%20atmosphere%2C%20no%20text%2C%20cinematic%20quality&width=800&height=600&seq=card-04&orientation=landscape',
  },
  {
    title: '《奔跑吧》最新季',
    desc: '国民综艺热血回归，明星阵容豪华升级，笑点密集欢乐不断。',
    tag: '综艺热播',
    tagColor: 'bg-accent-100 text-accent-700',
    img: 'https://readdy.ai/api/search-image?query=Vibrant%20energetic%20outdoor%20scene%20with%20warm%20sunlight%20and%20colorful%20abstract%20shapes%2C%20playful%20dynamic%20composition%2C%20bright%20cheerful%20atmosphere%2C%20no%20text%2C%20modern%20aesthetic&width=800&height=600&seq=card-05&orientation=landscape',
  },
  {
    title: '《鬼灭之刃》新篇',
    desc: '现象级日漫新篇章，茄子视频同步更新，战斗场面燃爆全场。',
    tag: '动漫新番',
    tagColor: 'bg-secondary-100 text-secondary-700',
    img: 'https://readdy.ai/api/search-image?query=Dynamic%20anime-style%20abstract%20composition%20with%20flowing%20energy%20waves%20in%20warm%20crimson%20and%20gold%20tones%2C%20dramatic%20lighting%2C%20motion%20blur%20effect%2C%20no%20text%2C%20artistic%20quality&width=800&height=600&seq=card-06&orientation=landscape',
  },
  {
    title: '《流浪地球3》',
    desc: '国产科幻巅峰续作，视觉效果再升级，人类命运史诗新篇章。',
    tag: '院线同步',
    tagColor: 'bg-primary-100 text-primary-700',
    img: 'https://readdy.ai/api/search-image?query=Epic%20cinematic%20landscape%20with%20dramatic%20sunset%20sky%20and%20silhouetted%20futuristic%20structures%2C%20warm%20orange%20and%20deep%20crimson%20gradients%2C%20grand%20scale%2C%20no%20text%2C%20movie%20poster%20quality&width=800&height=600&seq=card-07&orientation=landscape',
  },
];

export default function CardsSection() {
  return (
    <section id="cards" className="py-12 md:py-16 px-4 md:px-6 bg-background-50">
      <div className="max-w-[1200px] mx-auto">
        <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-900 text-center mb-2">精选推荐</h2>
        <p className="text-sm text-foreground-400 text-center mb-8 md:mb-10">编辑精选优质内容，每日更新不容错过</p>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {cards.slice(0, 6).map((card, idx) => (
            <a
              key={idx}
              href="#media"
              className="bg-background-100 rounded-lg overflow-hidden group cursor-pointer transition-all hover:bg-background-200"
            >
              <div className="aspect-[4/3] overflow-hidden bg-background-200">
                <img
                  src={card.img}
                  alt={card.title}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                />
              </div>
              <div className="p-4">
                <span className={`inline-block text-xs font-medium px-2 py-0.5 rounded-full mb-2 ${card.tagColor}`}>
                  {card.tag}
                </span>
                <h3 className="font-heading text-sm md:text-base font-semibold text-foreground-900 mb-1.5">{card.title}</h3>
                <p className="text-xs md:text-sm text-foreground-500 leading-relaxed">{card.desc}</p>
              </div>
            </a>
          ))}
        </div>
        <div className="mt-4 md:mt-5">
          <a
            key="card-6"
            href="#carousel"
            className="bg-background-100 rounded-lg overflow-hidden group cursor-pointer transition-all hover:bg-background-200 flex flex-col sm:flex-row"
          >
            <div className="sm:w-[320px] flex-shrink-0 aspect-[4/3] sm:aspect-auto overflow-hidden bg-background-200">
              <img
                src={cards[6].img}
                alt={cards[6].title}
                className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
              />
            </div>
            <div className="p-5 flex-1 flex flex-col justify-center">
              <span className={`inline-block text-xs font-medium px-2 py-0.5 rounded-full mb-2 self-start ${cards[6].tagColor}`}>
                {cards[6].tag}
              </span>
              <h3 className="font-heading text-sm md:text-base font-semibold text-foreground-900 mb-1.5">{cards[6].title}</h3>
              <p className="text-xs md:text-sm text-foreground-500 leading-relaxed">{cards[6].desc}</p>
            </div>
          </a>
        </div>
      </div>
    </section>
  );
}